import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import moment from "moment/moment";
import Authentication from "../Pages/Authentication";
import { Instagram, Facebook, Youtube } from "lucide-react";

const PinterestIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 2a10 10 0 0 0-3.5 19.4c-.05-.9-.1-2.3.02-3.3l1.1-4.7s-.28-.56-.28-1.4c0-1.3.76-2.27 1.7-2.27.8 0 1.19.6 1.19 1.32 0 .8-.51 2-0.78 3.11-.22.93.47 1.69 1.38 1.69 1.66 0 2.94-1.75 2.94-4.27 0-2.23-1.6-3.79-3.89-3.79-2.65 0-4.2 1.99-4.2 4.04 0 .8.31 1.66.7 2.13a.28.28 0 0 1 .06.27l-.26 1.07c-.04.17-.14.21-.32.13-1.2-.56-1.95-2.3-1.95-3.7 0-3.02 2.2-5.8 6.33-5.8 3.32 0 5.9 2.37 5.9 5.53 0 3.3-2.08 5.96-4.97 5.96-.97 0-1.88-.5-2.19-1.1l-.6 2.28c-.22.84-.81 1.9-1.2 2.54A10 10 0 1 0 12 2z" />
  </svg>
);

const Footer = () => {
  const { allCategory, callCategotyAPI } = useContext(MyContext);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  useEffect(() => {
    callCategotyAPI();
  }, [callCategotyAPI]);

  const firstShopLink =
    allCategory?.length > 0
      ? `/shop?catagoryId=${allCategory[0]?.CategoryId}`
      : "/shop";

  return (
    <div>
      <footer className="site-footer">
        <div className="container">
          <div className="site-footer-grid">
            <div className="site-footer-col site-footer-brand">
              <Link to="/" className="site-footer-brand-link">
                <img
                  src="/images/TRISA-LOGO.png"
                  alt="TRISA Jewellery"
                  className="site-footer-logo"
                />
              </Link>
              <p className="site-footer-tagline">
                Exquisite jewellery crafted with passion, precision and timeless
                elegance.
              </p>
              <div className="site-footer-social">
                <a
                  href="https://www.instagram.com/trisabypankajjewellers/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <Instagram size={18} strokeWidth={1.75} />
                </a>
                <a href="#" aria-label="Facebook">
                  <Facebook size={18} strokeWidth={1.75} />
                </a>
                <a href="#" aria-label="Pinterest">
                  <PinterestIcon size={18} />
                </a>
                <a href="#" aria-label="YouTube">
                  <Youtube size={18} strokeWidth={1.75} />
                </a>
              </div>
            </div>

            <div className="site-footer-col">
              <h3 className="site-footer-heading">Quick Links</h3>
              <ul className="site-footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/shop">Collections</Link>
                </li>
                <li>
                  <Link to={firstShopLink}>Jewellery</Link>
                </li>
                <li>
                  <Link to="/contact-us">About Us</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
              </ul>
            </div>

            <div className="site-footer-col">
              <h3 className="site-footer-heading">Customer Service</h3>
              <ul className="site-footer-links">
                <li>
                  <Link to="/order-details">Track Order</Link>
                </li>
                <li>
                  <Link to="/shipping-policy">Shipping &amp; Delivery</Link>
                </li>
                <li>
                  <Link to="/return-and-refund">Returns &amp; Exchange</Link>
                </li>
                <li>
                  <Link to="/contact-us">FAQ&apos;s</Link>
                </li>
                <li>
                  <Link to="/contact-us">Size Guide</Link>
                </li>
              </ul>
            </div>

            <div className="site-footer-col">
              <h3 className="site-footer-heading">Information</h3>
              <ul className="site-footer-links">
                <li>
                  <Link to="/shop">Blog</Link>
                </li>
                <li>
                  <Link to="/contact-us">Store Locator</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                </li>
              </ul>
            </div>

            <div className="site-footer-col site-footer-payments-col">
              <h3 className="site-footer-heading">We Accept</h3>
              <div className="site-footer-payments">
                <span className="payment-badge payment-visa" aria-label="Visa">
                  VISA
                </span>
                <span
                  className="payment-badge payment-mastercard"
                  aria-label="Mastercard"
                >
                  <span className="mc-circle mc-red" />
                  <span className="mc-circle mc-orange" />
                </span>
                <span
                  className="payment-badge payment-rupay"
                  aria-label="RuPay"
                >
                  RuPay
                </span>
                <span className="payment-badge payment-upi" aria-label="UPI">
                  UPI
                </span>
              </div>
            </div>
          </div>

          <div className="site-footer-bottom">
            <p>
              <span>© {moment().format("YYYY")}</span> Powered by{" "}
              <Link
                to="https://kodenauts.com/"
                target="_blank"
                rel="noreferrer"
              >
                Kodenauts
              </Link>
              . All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>

      <Authentication
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </div>
  );
};

export default Footer;
